import React from 'react';
import Navbar from '../components/header/Navbar';
import Footer from '../components/footer/Footer';

export default function MainLayout({ children, hideFooter }) {
  return (
    <div className="min-h-screen flex flex-col bg-parchment">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}
